import { Country } from "./country";
import { Language } from "./language";
import { LeadType } from "./lead-type";
import { School } from "./school";

export class LeadSearchOptions {

    constructor(
        public displayOption: number,
        public leadType: LeadType,
        public name: string,
        public school: School,
        public destination: Country,
        public email: string,
        public language: Language,
        public leadId: number,
        public interestedIn: string
    ){}
}
